import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import BaseForm, {FormValues} from './private/TeamInviteFormBase';
// import {TeamsModelType} from '../../models/TeamsModel';

// interface WithInjectedProps {
//   teams: TeamsModelType;
// }

@inject('teams')
@observer
export default class TeamInviteForm extends React.Component<{}, {}> {
  public render() {
    // const {isInvitingMembers} = this._withInjectedProps.teams;
    return (
      <Formik
        initialValues={this._initialValues}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => (
          <BaseForm {...props} loading={false} />
        )}
      />
    );
  }

  private get _initialValues(): FormValues {
    return {members: [{fullName: '', email: '', role: ''}]};
  }

  private _handleSubmit = ({members}: FormValues) => {
    // this._withInjectedProps.teams.inviteMembers(members);
  };

  private get _validationSchema() {
    return Yup.object().shape({
      members: Yup.array().of(
        Yup.object().shape({
          email: Yup.string()
            .email('Must be a valid email')
            .required('Requires an email'),
          role: Yup.string().required(
            `You must select this team member's role`
          )
        })
      )
    });
  }

  // private get _withInjectedProps() {
  //   return this.props as WithInjectedProps;
  // }
}



// WEBPACK FOOTER //
// ./src/containers/TeamInviteForm/TeamInviteForm.tsx